export default __webpack_public_path__ + "static/media/sagittarius.1cc96790.png";